export const videosAndDemos: {
  title: string;
  description: string;
  src: string;
  thumbnail: string;
}[] = [
  {
    title: "CXperience Builder for Amazon Connect",
    description:
      "CXperience Builder removes the Amazon Connect barrier to entry for ANY client size – and for scaled opportunities at 50 seats or more, serves up an immediate POC door opener to prove value and embed an AWS competitive edge.",
    src: "https://www.youtube.com/embed/ZC7vRwZ21l4",
    thumbnail: "https://img.youtube.com/vi/ZC7vRwZ21l4/maxresdefault.jpg",
  },
  {
    title: "Meet iRis, our GenAI concierge expert!",
    description:
      "Meet iRis, our GenAI concierge expert, built by iCXeed to show what practical AI in CX looks like. Watch how iRis handles complex queries with intelligent self-service powered by AWS and iCXeed innovation.",
    src: "https://www.youtube.com/embed/KNV8zGSVpFQ",
    thumbnail: "https://img.youtube.com/vi/KNV8zGSVpFQ/maxresdefault.jpg",
  },
  {
    title: "Get Cognitive CX with Amazon Connect",
    description:
      "See how iCXeed combines Amazon Connect with AWS analytics, AI, and automation to unlock Cognitive CX in your contact centre. Understand how our experts design and manage a cloud contact centre that keeps pace with your customers and your growth.",
    src: "https://www.youtube.com/embed/hnOKcZgZQRI",
    thumbnail: "https://img.youtube.com/vi/hnOKcZgZQRI/maxresdefault.jpg",
  },
  {
    title: "iCXeed - Cognitive CX Explained",
    description:
      "See how Cognitive CX connects analytics, AI, and automation to optimise every interaction across your contact centre. Learn how our team of experts turns data into action so you can work smarter at scale.",
    src: "https://www.youtube.com/embed/bH1NhdhQgm0",
    thumbnail: "https://img.youtube.com/vi/bH1NhdhQgm0/maxresdefault.jpg",
  },
  {
    title: "The iCXeed DNA Lab",
    description:
      "See how diskarte, talino, kusa, puso, angas, kulit, and tiyaga shape the iCXeed DNA that powers Cognitive CX innovation. Discover the Filipino traits that help our cognitive experts work smarter with analytics, AI, and automation.",
    src: "https://www.youtube.com/embed/1bwOvjl2mOc",
    thumbnail: "https://img.youtube.com/vi/1bwOvjl2mOc/maxresdefault.jpg",
  },
];
